export default class LogManager {
    static getInstance(){
      if (window.env === 'prod' || window.env === 'stage'){
        return new ProdLogManager();
      }
      return new LogManager();
    }

    constructor(){

    }

    // log in whatever condition
    logForSure(...params: any[]) {
      console.log(...params);
    }

    info(...params: any[]) {
      console.info(...params);
    }

    log(...params: any[]) {
      console.log(...params);
    }

    warn(...params: any[]) {
      console.warn(...params);
    }

    error(...params: any[]) {
      console.error(...params);
    }
}

class ProdLogManager extends LogManager{
    constructor(){
      super()
    }

    info(...params: any[]) {
      // do nothing
    }

    log(...params: any[]) {
      // do nothing
    }

    warn(...params: any[]) {
      console.warn(...params);
    }

    error(...params: any[]) {
      console.error(...params);
    }
}